import script from "./ConversationInternet.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversationInternet.vue?vue&type=script&setup=true&lang=js"

import "./ConversationInternet.vue?vue&type=style&index=0&id=5134b862&lang=css"

const __exports__ = script;

export default __exports__